import { ReactNode } from "react";
import { Box, Typography } from "./Mui";

interface CardProps {
  children: ReactNode;
}

function Card({ children }: CardProps) {
  return (
    <Box
      sx={{
        padding: "40px",
        borderRadius: "30px",
        background: "#171717",
        "@media(max-width: 640px)": {
          padding: "20px",
        },
      }}
    >
      {children}
    </Box>
  );
}

export function RedPockets() {
  return (
    <Box>
      <Typography
        sx={{
          color: "#fff",
          fontSize: "50px",
          fontWeight: 600,
          lineHeight: "50px",
          width: "100%",
          maxWidth: "744px",
        }}
      >
        Decentralized Red Packets & File Storage for Web3
      </Typography>

      <Box sx={{ margin: "54px 0 0 0" }}>
        <Box
          sx={{
            display: "grid",
            gap: "24px",
            alignItems: "stretch",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr",
            "@media(max-width: 640px)": {
              gridTemplateColumns: "1fr",
              gridTemplateRows: "1fr 1fr 1fr 1fr",
            },
          }}
        >
          <Card>
            <Box sx={{ height: "100%" }}>
              <Typography
                sx={{ color: "#fff", fontSize: "20px", fontWeight: 600 }}
              >
                Token Social Token Gifts
              </Typography>

              <Typography
                sx={{
                  margin: "12px 0 0 0",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "rgb(255 255 255 / 60%)",
                }}
              >
                Fully on-chain operation with no centralized control, ensuring
                transparent and trustworthy token gifts claim rules. Ideal for
                community engagement and event incentives.
              </Typography>

              <Box
                sx={{
                  margin: "27px 0 0 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "16px",
                    border: "1px solid #222",
                    background: "#131313",
                    padding: "22px 31px 16px",
                    display: "flex",
                    gap: "0 16px",
                    width: "304px",
                    "@media(max-width: 640px)": {
                      width: "100%",
                    },
                  }}
                >
                  <img
                    width="48px"
                    height="48px"
                    src="/images/token-gifts.svg"
                    alt=""
                  />

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "text.primary",
                      }}
                    >
                      Token Gifts
                    </Typography>

                    <Typography
                      sx={{
                        margin: "8px 0 0 0",
                        fontSize: "13px",
                        lineHeight: "13px",
                        color: "text.secondary",
                      }}
                    >
                      Supports random token gifts, equal token gifts, and custom
                      claim rules.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Card>

          <Card>
            <Box sx={{ height: "100%" }}>
              <Typography
                sx={{
                  color: "text.primary",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                File Sharing & Storage
              </Typography>

              <Typography
                sx={{
                  margin: "12px 0 0 0",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "text.secondary",
                }}
              >
                Suitable for secure storage and sharing of corporate data, NFT
                assets, and personal files.
              </Typography>

              <Box
                sx={{
                  margin: "65px 0 0 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px 20px",
                  "@media(max-width: 640px)": {
                    flexWrap: "wrap",
                  },
                }}
              >
                <img
                  width="94px"
                  height="94px"
                  src="/images/file-sharing-0.svg"
                  alt=""
                />

                <img
                  width="94px"
                  height="94px"
                  src="/images/file-sharing-1.svg"
                  alt=""
                />

                <img
                  width="94px"
                  height="94px"
                  src="/images/file-sharing-2.svg"
                  alt=""
                />
              </Box>
            </Box>
          </Card>

          <Card>
            <Box sx={{ height: "100%" }}>
              <Typography
                sx={{ color: "#fff", fontSize: "20px", fontWeight: 600 }}
              >
                100% Decentralized & Secure
              </Typography>

              <Typography
                sx={{
                  margin: "12px 0 0 0",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "text.secondary",
                }}
              >
                No traditional account system required; log in directly using
                Internet Identity or Web3 identity.
              </Typography>

              <Box
                sx={{
                  margin: "45px 0 0 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box sx={{ width: "100%", maxWidth: "304px" }}>
                  <img
                    width="100%"
                    src="/images/decentralized-secure.svg"
                    alt=""
                  />
                </Box>
              </Box>
            </Box>
          </Card>

          <Card>
            <Box sx={{ height: "100%" }}>
              <Typography
                sx={{ color: "#fff", fontSize: "20px", fontWeight: 600 }}
              >
                Gas-Free & Lightning-Fast Experience
              </Typography>

              <Typography
                sx={{
                  margin: "12px 0 0 0",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "text.secondary",
                }}
              >
                No gas fees, allowing users to store and share freely without
                the burden of high transaction costs from traditional wallets.
              </Typography>

              <Box
                sx={{
                  margin: "40px 0 0 0",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "16px",
                    border: "1px solid #222222",
                    background: "#131313",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "228px",
                    height: "126px",
                  }}
                >
                  <img src="/images/lightning-fast.svg" alt="" />
                </Box>
              </Box>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
